import React from 'react';
import { useNavigate } from 'react-router-dom';

const OnboardingLanding: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg bg-white rounded-lg shadow p-8 text-center">
      <h1 className="text-3xl font-bold mb-4">Unlimited design & dev, one active request at a time, flat monthly fee.</h1>
      <p className="mb-8 text-gray-600">Get started with a free trial or subscribe to a plan. Cancel anytime.</p>
      <button
        className="bg-primary text-white px-6 py-3 rounded font-semibold text-lg mr-4"
        onClick={() => navigate('/onboarding/signup')}
      >
        Start Free Trial
      </button>
      <button
        className="bg-gray-200 text-gray-800 px-6 py-3 rounded font-semibold text-lg"
        onClick={() => navigate('/onboarding/signup')}
      >
        Subscribe
      </button>
    </div>
  );
};

export default OnboardingLanding; 